import {
  createStore,
  createContainer,
  defaults,
  createHook,
} from 'react-sweet-state';
import { TState, TContainerProps } from '../common/types';
import { TActions, actions } from './actions';
import { initialState } from './state';
import { produce } from 'immer';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
defaults.mutator = (currentState, producer): any =>
  produce(currentState, producer);

defaults.devtools = true;

const Store = createStore<TState, TActions>({
  initialState,
  actions,
});

export const AppStateContainer = createContainer<
  TState,
  TActions,
  TContainerProps
>(Store);

export const useAppState = createHook(Store);
